(function () {
  var KLAVIYO_SELECTOR = [
    '[class*="kl-private-reset-css"]',
    '[class*="klaviyo"]',
    '[id*="klaviyo"]',
    'iframe[src*="klaviyo"]',
    'iframe[id*="klaviyo"]',
    'iframe[name*="klaviyo"]',
    'iframe[title*="Klaviyo"]',
    'iframe[title*="klaviyo"]',
  ].join(',');

  var HIDDEN_ATTRIBUTE = 'data-kl-flyout-hidden-by-guard';
  var PREV_VISIBILITY_ATTRIBUTE = 'data-kl-flyout-prev-visibility';
  var PREV_OPACITY_ATTRIBUTE = 'data-kl-flyout-prev-opacity';
  var PREV_POINTERS_ATTRIBUTE = 'data-kl-flyout-prev-pointer-events';
  var isScheduled = false;
  var popupLock = false;
  var lastPopupSeenAt = 0;
  var POPUP_RELEASE_MS = 8000;

  function intersectsViewport(rect) {
    var viewportWidth = window.innerWidth;
    var viewportHeight = window.innerHeight;
    return rect.bottom > 0 && rect.right > 0 && rect.top < viewportHeight && rect.left < viewportWidth;
  }

  function isVisible(element) {
    if (!element || !element.getBoundingClientRect) {
      return false;
    }

    var styles = window.getComputedStyle(element);
    if (styles.display === 'none' || styles.visibility === 'hidden' || Number(styles.opacity) < 0.05) {
      return false;
    }

    var rect = element.getBoundingClientRect();
    return rect.width > 40 && rect.height > 40 && intersectsViewport(rect);
  }

  function isCentered(rect, viewportWidth, viewportHeight) {
    var centerX = rect.left + rect.width / 2;
    var centerY = rect.top + rect.height / 2;
    return (
      Math.abs(centerX - viewportWidth / 2) < viewportWidth * 0.28 &&
      Math.abs(centerY - viewportHeight / 2) < viewportHeight * 0.3
    );
  }

  function isPopupLike(rect, viewportWidth, viewportHeight) {
    var hasPopupSize = rect.width > 320 && rect.height > 220;

    return isCentered(rect, viewportWidth, viewportHeight) && hasPopupSize;
  }

  function isFlyoutLike(rect, viewportWidth, viewportHeight) {
    var isEdgeAligned = rect.left < viewportWidth * 0.28 || rect.right > viewportWidth * 0.72;
    var isBottomOrMiddle = rect.bottom > viewportHeight * 0.5;
    var notFullscreen = rect.width < viewportWidth * 0.8 && rect.height < viewportHeight * 0.95;

    return isEdgeAligned && isBottomOrMiddle && notFullscreen;
  }

  function isInsideFooterKlaviyoDrawer(element) {
    if (!element || !element.closest) {
      return false;
    }

    return Boolean(
      element.closest('#Klaviyo-drawer') ||
      element.closest('account-drawer[data-type="klaviyo"]') ||
      element.closest('.template-klaviyo'),
    );
  }

  function getHideTarget(element) {
    var target = element;
    var steps = 0;

    while (target && target.parentElement && target.parentElement !== document.body && steps < 5) {
      // No ocultar nunca el contenedor principal del producto
      if (
        target.classList.contains('main-product') ||
        target.classList.contains('shopify-section') ||
        (target.id && target.id.indexOf('shopify-section-') === 0)
      ) {
        break;
      }

      var parent = target.parentElement;
      var parentRect = parent.getBoundingClientRect();
      var targetRect = target.getBoundingClientRect();

      // Si el padre es mucho más pequeño, seguramente ya hemos llegado
      // al contenedor del widget.
      if (parentRect.width < targetRect.width - 10 || parentRect.height < targetRect.height - 10) {
        break;
      }

      // Si el padre es muchísimo más grande, probablemente sea un
      // contenedor de layout (producto, sección, etc.).
      if (parentRect.width > targetRect.width * 1.5 || parentRect.height > targetRect.height * 1.5) {
        break;
      }

      target = parent;
      steps++;
    }

    return target;
  }

  function isFloatingOverlay(element) {
    // Los popups y flyouts reales de Klaviyo siempre flotan sobre la página
    // (position: fixed/sticky). El contenido embebido normalmente en el
    // layout (p.ej. la sección "Klaviyo form" insertada en una página) usa
    // position: static/relative y nunca debe poder ocultarse como si fuera
    // un flyout, aunque su posición en pantalla coincida puntualmente con
    // la geometría de un popup o de un flyout durante un reflow/animación.
    var position = window.getComputedStyle(element).position;
    return position === 'fixed' || position === 'sticky';
  }

  function getVisibleCandidates() {
    var nodes = Array.prototype.slice.call(document.querySelectorAll(KLAVIYO_SELECTOR));
    var unique = [];

    nodes.forEach(function (node) {
      if (isInsideFooterKlaviyoDrawer(node) || !isVisible(node)) {
        return;
      }

      var container = getHideTarget(node);
      if (
        container &&
        unique.indexOf(container) === -1 &&
        isVisible(container) &&
        isFloatingOverlay(container)
      ) {
        unique.push(container);
      }
    });

    return unique;
  }

  function hasVisiblePopup(candidates, viewportWidth, viewportHeight) {
    return candidates.some(function (element) {
      var rect = element.getBoundingClientRect();
      return isPopupLike(rect, viewportWidth, viewportHeight);
    });
  }

  function isLikelyCloseControl(target) {
    if (!target || !target.closest) {
      return false;
    }

    return Boolean(
      target.closest('[aria-label*="close" i]') ||
      target.closest('[class*="close" i]') ||
      target.closest('[id*="close" i]') ||
      target.closest('[data-testid*="close" i]') ||
      target.closest('[data-test-id*="close" i]'),
    );
  }

  function hideFlyout(element) {
    // `element` ya viene resuelto por getVisibleCandidates() (que llama a
    // getHideTarget). Volver a llamar getHideTarget aquí sobre un contenedor
    // ya resuelto le daba otros 5 pasos de margen para seguir subiendo por
    // el DOM, ocultando contenedores mucho más grandes de lo debido.
    var target = element;

    if (!target || target.getAttribute(HIDDEN_ATTRIBUTE) === 'true' || isInsideFooterKlaviyoDrawer(target)) {
      return;
    }

    target.setAttribute(HIDDEN_ATTRIBUTE, 'true');
    target.setAttribute(PREV_VISIBILITY_ATTRIBUTE, target.style.visibility || '');
    target.setAttribute(PREV_OPACITY_ATTRIBUTE, target.style.opacity || '');
    target.setAttribute(PREV_POINTERS_ATTRIBUTE, target.style.pointerEvents || '');
    target.style.setProperty('visibility', 'hidden', 'important');
    target.style.setProperty('opacity', '0', 'important');
    target.style.setProperty('pointer-events', 'none', 'important');
  }

  function restoreFlyouts() {
    var hiddenFlyouts = document.querySelectorAll('[' + HIDDEN_ATTRIBUTE + '="true"]');

    Array.prototype.forEach.call(hiddenFlyouts, function (element) {
      element.style.visibility = element.getAttribute(PREV_VISIBILITY_ATTRIBUTE) || '';
      element.style.opacity = element.getAttribute(PREV_OPACITY_ATTRIBUTE) || '';
      element.style.pointerEvents = element.getAttribute(PREV_POINTERS_ATTRIBUTE) || '';
      element.removeAttribute(HIDDEN_ATTRIBUTE);
      element.removeAttribute(PREV_VISIBILITY_ATTRIBUTE);
      element.removeAttribute(PREV_OPACITY_ATTRIBUTE);
      element.removeAttribute(PREV_POINTERS_ATTRIBUTE);
    });
  }

  function scheduleUpdate() {
    if (isScheduled) {
      return;
    }

    isScheduled = true;
    window.requestAnimationFrame(updateKlaviyoLayering);
  }

  function attemptReleaseFromCloseAction() {
    window.setTimeout(function () {
      var viewportWidth = window.innerWidth;
      var viewportHeight = window.innerHeight;
      var candidates = getVisibleCandidates();
      var popupStillVisible = hasVisiblePopup(candidates, viewportWidth, viewportHeight);

      if (!popupStillVisible) {
        popupLock = false;
        lastPopupSeenAt = 0;
        restoreFlyouts();
      }

      scheduleUpdate();
    }, 180);
  }

  function updateKlaviyoLayering() {
    isScheduled = false;

    var viewportWidth = window.innerWidth;
    var viewportHeight = window.innerHeight;
    var candidates = getVisibleCandidates();
    var now = Date.now();
    var popupFound = hasVisiblePopup(candidates, viewportWidth, viewportHeight);

    if (popupFound) {
      popupLock = true;
      lastPopupSeenAt = now;
    }

    if (!popupFound && popupLock && now - lastPopupSeenAt > POPUP_RELEASE_MS) {
      popupLock = false;
    }

    if (!popupLock) {
      restoreFlyouts();
      return;
    }

    var popupContainers = candidates.filter(function (element) {
      return isCentered(element.getBoundingClientRect(), viewportWidth, viewportHeight);
    });

    candidates.forEach(function (element) {
      var isInsidePopup = popupContainers.some(function (popupElement) {
        return popupElement !== element && popupElement.contains(element);
      });

      if (isInsidePopup) {
        return;
      }

      var rect = element.getBoundingClientRect();
      if (isFlyoutLike(rect, viewportWidth, viewportHeight) && !isCentered(rect, viewportWidth, viewportHeight)) {
        hideFlyout(element);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', scheduleUpdate);
  window.addEventListener('load', scheduleUpdate);
  window.addEventListener('resize', scheduleUpdate);
  window.addEventListener('scroll', scheduleUpdate, true);
  window.addEventListener('klaviyoForms', scheduleUpdate);
  document.addEventListener(
    'click',
    function (event) {
      if (isInsideFooterKlaviyoDrawer(event.target)) {
        return;
      }

      if (isLikelyCloseControl(event.target)) {
        attemptReleaseFromCloseAction();
        return;
      }

      scheduleUpdate();
    },
    true,
  );
  document.addEventListener(
    'keyup',
    function (event) {
      if (event && event.key === 'Escape') {
        attemptReleaseFromCloseAction();
        return;
      }

      scheduleUpdate();
    },
    true,
  );

  var observer = new MutationObserver(scheduleUpdate);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style', 'src'],
  });
})();
